/**
 * @ngdoc Controller
 * @name RemoteConfigurationController
 */
import { handleFileDownload } from "@/utils/download";
import {
    enableUpdateChecks,
    disableUpdateChecks,
} from "@/version/update-detector";

(function () {
    'use strict';

    angular.module('vrm.core')
        .controller('RemoteConfigurationController', RemoteConfigurationController);

    /**
     * @constructor
     * @ngInject
     */
    function RemoteConfigurationController(
        $log,
        $scope,
        $stateParams,
        $state,
        ApiService,
        MQTTService,
        $q,
        InstallationsService,
        vrmNotificationsService,
        vrmNotificationType,
        VrmModalService,
        locale,
        $timeout
    ) {
        $log.info('RemoteConfigurationController');
        disableUpdateChecks();
        $scope.defaultStatus = null;
        $scope.forms = {};
        $scope.model = {};
        $scope.services = null;
        $scope.progress = 0;
        $scope.status = null;
        $scope.downloading = false;
        $scope.uploading = false;
        $scope.configuring = false;
        $scope.fetchingError = false;

        $scope.$watch('installation.identifier', function () {
            if (!$scope.installation)
                return;
            MQTTService.setPortalId($scope.installation.identifier);
            MQTTService.subscribe();
        });


        locale.ready('remote-configuration').then(function () {
            $scope.defaultStatus = locale.getString('remote-configuration.waiting_for_status_updates');
            if (!$scope.status)
                $scope.status = $scope.defaultStatus;
        });

        $scope.fetchConfigurableServices = function () {
            $scope.services = null;
            $scope.fetchingError = null;
            $q.all([
                InstallationsService.getInstallation($stateParams.id),
                ApiService.call('/installations/' + $stateParams.id + '/vebus-list', null, 'GET', false, 'json', false)])
                .then(function (result) {
                    var installation = result[0];
                    var response = result[1];

                    redirectUnauthorizedUser(installation);

                    $scope.installation = installation;
                    $scope.services = response.data.services;
                    if ($scope.services.length > 0) {
                        $scope.model.service = $scope.services[0];
                    }
                })
                .catch(function (response) {
                    // Non-full-access user shouldn't be able to access this page
                    if (response.status === 403) {
                        InstallationsService.getInstallation($stateParams.id).then(function (installation) {
                            redirectUnauthorizedUser(installation);
                        });
                    }
                    if (response.data && ('error_message_code' in response.data)) {
                        fetchingError(response.data.error_message_code, response.data.error_message, response.data.error_code);
                    }
                    $scope.fetchingError = true;
                });
        };

        const redirectUnauthorizedUser = (installation) => {
            if (
                !(installation.view_permissions.update_settings &&
                    installation.view_permissions.mqtt_rpc &&
                    installation.view_permissions.twoway &&
                    installation.view_permissions.vebus)
            ) {
                InstallationsService.redirectUnauthorizedUser(installation);
            }
        }

        $scope.fetchConfigurableServices();

        $scope.download = function () {
            $scope.downloading = true;
            VrmModalService.openDownloadConfigurationModal($scope);
            var path = '/installations/' + $stateParams.id + '/veconf-read?serviceName=' + $scope.model.service.servicename;

            var configurationReadCallback = function (message) {
                var payload = message.payload;
                $scope.progress = payload.progress;
                $scope.status = payload.status;
                if ($scope.progress < 0) {
                    $scope.downloading = false;
                    downloadError(payload.error_message_code, payload.error_message, payload.error_code);
                }

                if (payload.success && payload.file) {
                    // Normalize and remove diacritics
                    const siteName = $scope.installation.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                
                    // Remove special characters, keep only alphanumeric and spaces, and replace spaces with underscores
                    const sanitizedDeviceName = siteName.replace(/[^a-zA-Z0-9\s]/g, '').trim().replace(/\s+/g, '_');
                    const fileName = (sanitizedDeviceName ? sanitizedDeviceName + '_' : '') + payload.file.filename;
                
                    handleFileDownload(base64toBlob(payload.file.content), fileName);
                    $scope.downloading = false;
                    resetProgress();
                    $.magnificPopup.close();
                }
                $scope.$applyAsync();
            };

            MQTTService.subscribeToPath({
                identifier: $scope.installation.identifier,
                dbusServiceType: "status/vrm_veconf_read",
                dbusPath: "",
                instance: "",
                callback: configurationReadCallback,
                callbackIdentifier: "veconf_read",
                prefix: "P/"
            });
            ApiService.call(path, null, 'GET', false, 'json', false)
                .then(function () {
                    //
                })
                .catch(function (response) {
                    if (response.data && ('error_message_code' in response.data)) {
                        downloadError(response.data.error_message_code, response.data.error_message, response.data.error_code);
                    }
                });
        };

        $scope.upload = function () {
            VrmModalService.openUploadModal($scope, 'veconf', function (files) {
                if (files.length == 1 && (files[0].name.split(".").pop() === 'rvsc' || files[0].name.split(".").pop() === 'rvms')) {
                    var file = files[0];
                    var data = new FormData();
                    data.append('serviceName', $scope.model.service.servicename);
                    fileToBase64(file).then(function (base64Content) {
                        data.append('file', base64Content);

                        $scope.configuring = true;
                        // Upload modal has 500ms removalDelay that need to wait before starting configuring
                        $timeout(function () {
                            VrmModalService.openConfiguringModal($scope);
                            var configurationWriteCallback = function (message) {
                                var payload = message.payload;
                                $scope.progress = payload.progress;
                                $scope.status = payload.status;
                                if ($scope.progress < 0) {
                                    $scope.configuring = false;
                                    configurationError(payload.error_message_code, payload.error_message, payload.error_code);

                                }

                                if ($scope.progress >= 100) {
                                    $scope.configuring = false;
                                    configurationSuccess();
                                }

                                $scope.$applyAsync();
                            };

                            MQTTService.subscribeToPath({
                                identifier: $scope.installation.identifier,
                                dbusServiceType: "status/vrm_veconf_write",
                                dbusPath: "",
                                instance: "",
                                callback: configurationWriteCallback,
                                callbackIdentifier: "veconf_write",
                                prefix: "P/"
                            });

                            var path = '/installations/' + $stateParams.id + '/veconf-write';
                            ApiService.call(path, data, 'POST', false, 'json', false)
                                .then(function () {

                                })
                                .catch(function (response) {
                                    if (response.data && ('error_message_code' in response.data)) {
                                        configurationError(response.data.error_message_code, response.data.error_message, response.data.error_code);
                                    } else {
                                        resetProgress();
                                    }
                                });
                        }, 510);
                    });
                } else {
                    uploadError();
                }
            });

        };

        function base64toBlob(base64Data, contentType) {
            contentType = contentType || '';
            var sliceSize = 1024;
            var byteCharacters = atob(base64Data);
            var bytesLength = byteCharacters.length;
            var slicesCount = Math.ceil(bytesLength / sliceSize);
            var byteArrays = new Array(slicesCount);

            for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                var begin = sliceIndex * sliceSize;
                var end = Math.min(begin + sliceSize, bytesLength);

                var bytes = new Array(end - begin);
                for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                    bytes[i] = byteCharacters[offset].charCodeAt(0);
                }
                byteArrays[sliceIndex] = new Uint8Array(bytes);
            }
            return new Blob(byteArrays, { type: contentType });
        }

        function fileToBase64(file) {
            var deferred = $q.defer();
            var reader = new FileReader();
            reader.onload = function () {
                deferred.resolve(reader.result.split(',')[1]);
            };
            reader.readAsDataURL(file);
            return deferred.promise;
        }

        function configurationSuccess() {
            $.magnificPopup.close();
            VrmModalService.openSuccessModal($scope, 'remote-configuration.configuration-success');
            resetProgress();
        }

        function fetchingError(errorMessageCode, errorMessage, errorCode) {
            $.magnificPopup.close();
            errorMessageCode = errorMessageCode || 'fetching-services-error-full';
            errorMessageCode = errorMessageCode.split('.').join('-');
            var errorMsgKey = 'remote-configuration.' + errorMessageCode;
            VrmModalService.openErrorModal($scope, errorMsgKey, errorMessage, errorCode);
            $scope.fetchingError = true;
        }

        function uploadError() {
            // Upload modal has 500ms removalDelay that need to wait before error
            $timeout(function () {
                VrmModalService.openErrorModal($scope, 'remote-configuration.file-upload-error');
            }, 510);
        }

        function downloadError(errorMessageCode, errorMessage, errorCode) {
            $.magnificPopup.close();
            errorMessageCode = errorMessageCode || 'download-error';
            errorMessageCode = errorMessageCode.split('.').join('-');
            var errorMsgKey = 'remote-configuration.' + errorMessageCode;
            VrmModalService.openErrorModal($scope, errorMsgKey, errorMessage, errorCode);
            resetProgress();
        }

        function configurationError(errorMessageCode, errorMessage, errorCode) {
            $.magnificPopup.close();
            errorMessageCode = errorMessageCode || 'configuration-error';
            errorMessageCode = errorMessageCode.split('.').join('-');
            var errorMsgKey = 'remote-configuration.' + errorMessageCode;
            VrmModalService.openErrorModal($scope, errorMsgKey, errorMessage, errorCode);
            resetProgress();
        }

        function resetProgress() {
            $scope.status = $scope.defaultStatus;
            $scope.progress = 0;
            unsubscribe();
        }

        function unsubscribe() {
            MQTTService.unsubScribeFromPath({
                identifier: $scope.$parent.installation.identifier,
                dbusServiceType: "status/vrm_veconf_read",
                dbusPath: "",
                instance: "",
                callbackIdentifier: "veconf_read",
                prefix: "P/"
            });

            MQTTService.unsubScribeFromPath({
                identifier: $scope.$parent.installation.identifier,
                dbusServiceType: "status/vrm_veconf_write",
                dbusPath: "",
                instance: "",
                callbackIdentifier: "veconf_write",
                prefix: "P/"
            });

            MQTTService.unsubScribeFromPath({
                identifier: $scope.installation.identifier,
                dbusServiceType: "system/0/Serial",
                dbusPath: "",
                instance: "",
                callbackIdentifier: "veconf_serial"
            });
            MQTTService.unsubscribe();
        }



        $scope.$on('$destroy', function () {
            unsubscribe();
            enableUpdateChecks();
        });

    }

})();
